<template lang="pug">
  .pRow
    .pRow__chatBody.d-inline-block.position-relative
      .chatBody__outSideBox
        .row.flex-row-reverse.no-gutters.align-items-start.flex-nowrap
          .pRow__profileImg.ml-3(
            v-if="this.profile_picture",
            @click="showLightBox(profile_picture)"
          )
            ProfilePhotoSticker.d-flex.align-items-center.justify-content-center(
              :profileUrl="this.profile_picture",
              :style="{ 'width': '50px', 'height': '50px' }"
            )
          .d-flex.align-items-end.flex-nowrap.flex-row-reverse.no-gutters
            .pRow__content.pRow__imgBox.position-relative.d-flex.align-items-center
              .imgBox__insideImgBox
                .chatBox__carouselBox.d-inline-block.position-relative.overflow-auto(
                  style="white-space: nowrap;"
                )
                  .inSideBox__bubble.d-inline-block.rounded.mr-2(
                    v-for="(bubble,index) in messageData.bubbles",
                    :class="{'w-100': messageData.bubbles.length === 1, 'mr-2': messageData.bubbles.length > 1 && messageData.bubbles.length !== index + 1}"
                  )
                    //- 上方圖片區
                    .bubble__upPart.position-relative.rounded-top
                      b-img.rounded.cursor-pointer.w-100(
                        v-lazy="bubble.image",
                        fluid,
                        alt="Personnel Send Img",
                        :onerror="defaultPreviewImg",
                        @click="showLightBox(bubble.image)"
                      )
                    //- 下方文字區塊
                    .bubble__downPart.position-relative.p-2.rounded-bottom.bg-white
                      h4(:class="{ 'text-left': bubble.title_align === 'start', 'text-center': bubble.title_align === 'center', 'text-right': bubble.title_align === 'end' }", :style="{ color: bubble.title_color }") {{ bubble.title }}
                      span.d-block.defaultTextColor.white-space-pre-line(:class="{ 'text-left': bubble.message_align === 'start', 'text-center': bubble.message_align === 'center', 'text-right': bubble.message_align === 'end' }", :style="{ color: bubble.message_color }") {{ bubble.message }}
                      hr.hr(v-if="bubble.buttons.length > 0")
                      .buttonBox.position-relative(v-for="button in bubble.buttons")
                        span.text-center.d-block.pb-1(v-if="button.actionType === 'message'") {{ button.label }}
                        a.text-center.d-block.pb-1(v-else-if="button.actionType === 'uri'", :href="button.uri", target='_blank' rel="noopener noreferrer nofollow") {{ button.label }}
            .pRow__timeBox
              span.text-right(
                v-if="this.messageData.is_read"
              ) 已讀
              span.cursor-default.text-right {{ filterToday(this.messageData.time) }}
</template>

<script>
import ProfilePhotoSticker from '@/components/profilePhotoSticker/ProfilePhotoStickerComponent.vue';
import defaultPreviewImgUrl from '@/assets/images/default/defaultImg404.png';

export default {
  name: 'P-Carousel',
  components: {
    ProfilePhotoSticker
  },
  props: {
    messageData: {
      type: Object,
      required: true
    },
    profile_picture: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      defaultPreviewImg: `this.src="${defaultPreviewImgUrl}"`
    };
  },
  methods: {
    // 通知父組件顯示幻燈片
    showLightBox(imageUrl) {
      this.$emit('showLightBox', imageUrl);
    }
  }
};
</script>

<style lang="scss" scoped>
// 每一個 bubbles
.inSideBox__bubble {
    white-space: normal;
    display: inline-block;
    vertical-align: top!important;
    transition: all 0.8s ease;
    width: 80%;
    height: 100%;
    background-color: #f3f4f7;
    // 每一個 bubble 的圖片外框div
    .bubble__upPart {
        // min-height: 40%;
    }
    // 每一個 bubble 的下方文字區
    .bubble__downPart {
        // height: 60%;
        border: 1px solid #eee;
        border-top: none;
        .hr {
            margin-top: 1rem;
            margin-bottom: 1rem;
            border: 0;
            border-top: 1px solid rgba(0, 0, 0, 0.1);
        }
    }
}
</style>
